/* tslint:disable */
/* eslint-disable */
/**
 * SBL API Glommen Mjøsen Skog
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { GmModelLibraryModelsReallocatedAreaModel } from '../model';
/**
 * ReallocatedAreaApi - axios parameter creator
 * @export
 */
export const ReallocatedAreaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get reallocated areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reallocatedAreaGetReallocatedAreas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/reallocatedAreas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReallocatedAreaApi - functional programming interface
 * @export
 */
export const ReallocatedAreaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReallocatedAreaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get reallocated areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reallocatedAreaGetReallocatedAreas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GmModelLibraryModelsReallocatedAreaModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reallocatedAreaGetReallocatedAreas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ReallocatedAreaApi.reallocatedAreaGetReallocatedAreas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ReallocatedAreaApi - factory interface
 * @export
 */
export const ReallocatedAreaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReallocatedAreaApiFp(configuration)
    return {
        /**
         * 
         * @summary Get reallocated areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reallocatedAreaGetReallocatedAreas(options?: any): AxiosPromise<Array<GmModelLibraryModelsReallocatedAreaModel>> {
            return localVarFp.reallocatedAreaGetReallocatedAreas(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReallocatedAreaApi - object-oriented interface
 * @export
 * @class ReallocatedAreaApi
 * @extends {BaseAPI}
 */
export class ReallocatedAreaApi extends BaseAPI {
    /**
     * 
     * @summary Get reallocated areas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReallocatedAreaApi
     */
    public reallocatedAreaGetReallocatedAreas(options?: RawAxiosRequestConfig) {
        return ReallocatedAreaApiFp(this.configuration).reallocatedAreaGetReallocatedAreas(options).then((request) => request(this.axios, this.basePath));
    }
}

